(function () {
  const breadcrumb = document.querySelector<HTMLElement>('.kf-o-breadcrumb');
  const items = breadcrumb?.querySelectorAll<HTMLElement>('.kf-o-breadcrumb__item');

  // Calculate the total number of characters in all breadcrumb items
  const maxCharacters = 95;
  let totalCharacters = 0;

  items?.forEach((item) => {
    // Check if the total characters exceed the maximum limit
    if (totalCharacters >= maxCharacters) {
      // Remove the current item if the limit is exceeded
      item.remove();

      return;
    } else {
      totalCharacters += item.textContent ? item.textContent.trim().length : 0;

      // Check if the total characters exceed the maximum limit after the current item
      if (totalCharacters > maxCharacters) {
        // Truncate the text of the current item
        const currentText = item.textContent || '';
        const truncatedText = currentText.slice(0, maxCharacters - totalCharacters) + '...';

        item.textContent = truncatedText;
      } else {
        // Remove the title attribute from the anchor tag if it exists, as it is not needed
        item.querySelector('a')?.removeAttribute('title');
      }
    }
  });

  const backButton = document.querySelector<HTMLElement>('.kf-o-back-navigation__inner > button');

  if (backButton) {
    backButton.addEventListener('click', () => {
      history.back();
    });
  }
})();
